<template>
    <div>
        <app-header title="Meine Konto"></app-header>
        <div class="page">
            <table class="header">
                <tr>
                    <td>
                        <h1>Aktuelles Guthaben</h1>
                        <h2>CHF 9542.50</h2>
                        <h4>Aktualisiert am 18 Juni 2018</h4>
                    </td>
                    <td>
                        <img src="../../assets/images/mein_konto.png">
                    </td>
                </tr>
            </table>
            <router-link :to="{name: 'guthaben_auszahlen'}" class="row-guthaben" tag="div">
                <span>Guthaben auszahlen</span>
                <div class="img"><img src="../../assets/images/next.png"></div>
            </router-link>
            <div class="table-title">
                <img src="../../assets/images/mein_konto_icon.png">
                <span>
                    Transaktionen Verlauf
                </span>
            </div>
            <table class="transaktioren">
                <router-link :to="{name: 'konto_detail'}" tag="tr">
                    <td>
                        <h3>Januar 2018</h3>
                        <h4>Jan 2018</h4>
                    </td>
                    <td>
                        <h3>+ CHF 573.40</h3>
                        <span class="green">Gutschrift</span>
                    </td>
                    <td><img src="../../assets/images/next.png"></td>
                </router-link>
                <router-link :to="{name: 'konto_detail'}" tag="tr">
                    <td>
                        <h3>Korrektur für Deze...</h3>
                        <h4>01 Feb 2018</h4>
                    </td>
                    <td>
                        <h3>-CHF 306.80</h3>
                        <span class="red">Lastschrift</span>
                    </td>
                    <td><img src="../../assets/images/next.png"></td>
                </router-link>
                <router-link :to="{name: 'konto_detail'}" tag="tr">
                    <td>
                        <h3>Dezember 2017</h3>
                        <h4>Jan 2018 - Feb 2018</h4>
                    </td>
                    <td>
                        <h3>+ CHF 293.20</h3>
                        <span class="green">Gutschrift</span>
                    </td>
                    <td><img src="../../assets/images/next.png"></td>
                </router-link>
                <router-link :to="{name: 'konto_detail'}" tag="tr">
                    <td>
                        <h3>November 2017</h3>
                        <h4>Feb 2018</h4>
                    </td>
                    <td>
                        <h3>+ CHF 107.90</h3>
                        <span class="green">Gutschrift</span>
                    </td>
                    <td><img src="../../assets/images/next.png"></td>
                </router-link>
            </table>


        </div>

    </div>
</template>

<script>
    import Header from '../Header';
    import Footer from '../Footer_menu'

    export default {
        computed: {
            items() {
                return this.$store.getters.Meine_trends;
            }
        },
        components: {
            appHeader: Header,
            appFooter: Footer
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/css/style';

    .page {
        padding-top: 60px;
        color: #252226;
        overflow: hidden;

        table.header {
            width: 100%;

            td:first-of-type {
                width: 77.5%;
                padding-top: 20px;
                padding-left: 20px;

                h1 {
                    font-size: 2.0rem;
                    font-weight: 400;
                    letter-spacing: -0, 24px;
                    line-height: 28px;
                    margin-bottom: 3px;
                }

                h2 {
                    font-weight: 700;
                    font-size: 1.9rem;
                    margin-bottom: 3px;

                }

                h4 {
                    color: #838289;
                    font-size: 1.1rem;
                    letter-spacing: -0.3px;
                }
            }

            td:last-of-type {
                width: available;

                img {
                    padding-top: 10px;
                }
            }
        }

        .row-guthaben {
            margin-top: 20px;
            display: table;
            width: 100%;
            height: 55px;
            border-top: 1px solid #dfdfdf;
            border-bottom: 1px solid #dfdfdf;

            span {
                padding-left: 20px;
                display: table-cell;
                vertical-align: middle;
                color: $button_full_backGroundColor;
                font-size: 1.5rem;
                font-weight: 600;
            }

            div {
                display: table-cell;
                vertical-align: middle;
                text-align: right;
                padding-right: 15px;
            }
        }

        .table-title {
            margin-top: 33px;
            margin-left: 20px;

            span {
                font-size: 1.1rem;
                letter-spacing: -0, 24px;
                color: #252226;
                margin-left: 7px;
            }
        }

        table.transaktioren {
            border-left: 2px $lila solid;
            margin-left: 25px;
            margin-top: 12px;

            td {
                &:nth-of-type(1) {
                    width: 66%;
                    padding: 15px 0 10px 14px;

                }

                &:nth-of-type(2) {
                    padding-top: 10px;
                    width: 31% !important;

                    text-align: right;
                }

                &:nth-of-type(3) {
                    width: max-content;
                    padding: 12px;
                }

                h3 {
                    font-size: 1.4rem;
                    letter-spacing: -0, 24px;
                    font-weight: 600;
                    margin-bottom: 1px;
                }

                h4 {
                    color: #252226;
                    font-weight: 300;
                    font-size: 1.2rem;
                    margin-top: 5px;
                }

                span {
                    font-size: 1.2rem;
                    display: block;

                    &.green {
                        color: $success;
                    }

                    &.red {
                        color: $warning;
                    }
                }
            }
        }


    }


</style>



// WEBPACK FOOTER //
// src/components/konto/Konto.vue